export function ensureHTTPS(value: string): string {
    if (typeof value !== 'string' || value.length <= 0) {
        return '';
    }
    const regx = /http:/g;
    return value.replace(regx, 'https:');
}